/**
 * router
 */
export const QUERY_STRING_UPDATE = 'QUERY_STRING_UPDATE';
export const QUERY_STRING_DELETE = 'QUERY_STRING_DELETE';
export const QUERY_STRING_RESET = 'QUERY_STRING_RESET';
export const PUSH_WITH_STORED_SEARCH = 'PUSH_WITH_STORED_SEARCH';
